import React from "react";
import PropTypes from "prop-types";

import styles from "./CommitteeMemberItem.module.css";

export function CommitteeMemberItem({ name, photo, year, onClickPhoto }) {
  return (
    <div className={styles.memberItemContainer}>
      <img src={photo} alt={`${name}`} className={styles.memberImage} onClick={onClickPhoto} />
      <div>{name}</div>
      <div className={styles.memberSince}>{year && `Since ${year}`}</div>
    </div>
  );
}

CommitteeMemberItem.propTypes = {
  /**
   * Committee members name
   */
  name: PropTypes.string,
  /**
   * Path to committee members photo
   */
  photo: PropTypes.string,
  /**
   * Year displayed beneath the photo
   */
  year: PropTypes.number,
};
